<template lang="pug">
  div.h-100
    div.box-list-filter(v-if="showFilters")
      div.box-list-filter__firstColumn(v-if="!hide_first_level")
        ul(
          v-for="node in nodes"
          :class="classShowArrow(node.id)"
          :key="node.id"
          ref="nodes"
          :id="node.id + 'parent'"
          @click="showTree(node)"
        )
          span {{ node.name }}
          button(
            @click.stop="showTree(node)"
            :id="node.id + '_arrow'"
          )
            i(
              :class="parentClass(node.id)"
            )
      div(
        v-if="showPanel"
        id='filter_second_column'
        ref='showRigthPanel'
        :class="childrenListClass()"
      )
        div(
          @clickaway="clickAway"
          :class="filterListClass()"
        )
          div.mh-60.resultTree__index--scrollable(ref="scrollableColumn")
            ul.list-unstyled.list-origin
              div(
                class = 'd-flex flex-column'
              )
                div(
                  id='filter_name'
                  class = 'filterName py-0 pl-0'
                  v-if="!hide_first_level"
                ) {{current_node.name}}
                p(
                  v-if="show_all_result"
                  id='all_node_results'
                  class = 'all-results mb-0'
                  @click="selected_value(current_node.id)"
                ) {{navigation_label}}
              forms-tree-node-vue(
                v-for="node in current_node.children"
                :id="node.id"
                :key="node.id"
                v-bind="node"
                :name="node.name"
                :children="node.children"
                :total="node.updates_count"
                :counts_visible="counts_visible"
                ref="children"
                class="form-check-label pl-0"
                @value_selected="selected_value"
                :filter_name="filter_name"
              )
</template>

<script>
import mixins from 'common/mixins.js'
import MultipleAutocompleteTreeSelector from 'components/forms/MultipleAutocompleteTreeSelector'
import { mapMutations } from "vuex"

export default {
  name: 'forms-navigation-tree-vue',
  props: {
    nodes: { type: Array, default: () => [] },
    value: { type: String, default: () => "" },
    counts_visible: { type: Boolean, default: () => true },
    show_all_result: { type: Boolean, default: () => false },
    navigation_label: { type: String, default: () => '' },
    hide_first_level: { type: Boolean, default: false},
    filter_name: { type: String, default: '' }
  },
  mixins: [mixins.filters, mixins.translate],
  extends: MultipleAutocompleteTreeSelector,
  components: {
    'forms-tree-node-vue': () => import(
      /* webpackChunkName: "[request]" */ 'components/forms/TreeNode'
    )
  },
  data: function () {
    return {
      showFilters: true
    }
  },
  computed: {
    showPanel() {
      return Object.keys(this.current_node).length !== 0
    }
  },
  methods: {
    async selected_value(nodeSelected) {
      this.disableBackdrop()
      await this.$emit('input', nodeSelected)
      if(!this.hide_first_level){
        this.current_node = {}
      }
      this.scrollToLabel()
    },
    childrenListClass(){
      return this.hide_first_level ? '' : 'box-list-filter__secondColumn'
    },
    filterListClass(){
      return this.hide_first_level ? '' : 'box-list-filter__secondColumn--filter'
    },
    clickAway(){
      if(!this.hide_first_level){
        this.hideFilters
      }
    }
  },
  mounted(){
    if(this.hide_first_level) {
      if(this.nodes && this.nodes[0])
        this.showTree(this.nodes[0])
    }
  }
}
</script>
